import { render, staticRenderFns } from "./RingTreeActions.vue?vue&type=template&id=64716b51"
import script from "./RingTreeActions.vue?vue&type=script&lang=js"
export * from "./RingTreeActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports